export enum GetMoodsCallType {
  profile = 'profile',
  chart = 'chart',
}
